<template>
  <v-layout row wrap justify-center>
    <pg-detail
      :title="title"
      :primary_key="primary_key"
      :primary_field="primary_field"
      :deleteProcess="deleteDialog"
      checkCreator
      @found="selected = [$event]"
      @add="openInputDialog('ADD')"
      @update="openInputDialog('UPDATE')"
      @delete="deleteDialog = true"
    >
      <template slot="detail-content" slot-scope="props">
        <v-layout wrap>
          <v-flex sm12 md6>
            <v-carousel style="height: 300px" class="mb-4" v-viewer>
              <v-carousel-item
                v-for="(item, i) in props.detail.photos"
                :key="`detail-carousel-${i}`"
                :src="c.PHOTO_TRAINING_URL + item.pel_photo"
              >
              </v-carousel-item>
              <v-carousel-item
                v-if="!props.detail.photos.length"
                :src="c.PHOTO_TRAINING_URL + 'no-image.png'"
              >
              </v-carousel-item>
              <v-icon
                large
                @click="showViewer"
                class="secondary white--text"
                style="position: absolute; top: 0; right: 0"
                >fullscreen</v-icon
              >
              <div class="images-viewer" style="display: none" v-viewer>
                <img
                  v-for="(item, i) in props.detail.photos"
                  :key="`detail-viewer-${i}`"
                  :src="c.PHOTO_TRAINING_URL + item.pel_photo"
                  :alt="`Photo ke-${i}`"
                />
                <img
                  v-if="!props.detail.photos.length"
                  :src="c.PHOTO_TRAINING_URL + 'no-image.png'"
                  alt="No Image"
                />
              </div>
            </v-carousel>
            <v-card-title class="subheading pl-0 pb-0">CLIENT</v-card-title>
            <v-chip
              v-for="client in props.detail.clients"
              :key="`detail-clients-${client.id_client}`"
              color="secondary"
              small
              text-color="white"
            >
              <router-link
                :to="{ name: 'ClientList', query: { id: client.id_client } }"
                class="white--text"
                style="text-decoration: none"
              >
                <v-avatar class="primary">{{ client.peserta_hadir }}</v-avatar>
                {{ client.client }}
              </router-link>
            </v-chip>
            <v-divider class="my-2"></v-divider>
            <v-card-title class="subheading pl-0 pb-0">TRAINER</v-card-title>
            <v-chip
              v-for="trainer in props.detail.trainers"
              :key="`detail-trainers-${trainer.id_trainer}`"
              color="grey"
              small
              label
              text-color="white"
            >
              <router-link
                :to="{ name: 'TrainerList', query: { id: trainer.id_trainer } }"
                class="white--text"
                style="text-decoration: none"
              >
                {{ trainer.trainer }}
              </router-link>
            </v-chip>
            <v-divider class="my-2"></v-divider>
            <template v-if="props.detail.files.length > 0">
              <v-card-title class="subheading pl-0 pb-0">DOKUMEN</v-card-title>
              <v-divider class="mb-2"></v-divider>
              <v-chip
                v-for="file in props.detail.files"
                :key="`detail-files-${file.id_pel_file}`"
                color="indigo"
                small
                label
                text-color="white"
              >
                <a
                  :href="
                    props.detail.files | downloaderFiles(file.pel_file_tipe)
                  "
                  class="white--text"
                  style="text-decoration: none"
                >
                  {{ file.pel_file_tipe }}
                </a>
              </v-chip>
            </template>
          </v-flex>
          <v-flex sm12 md6>
            <v-list two-line subheader>
              <v-list-tile
                v-ripple
                :to="{ name: 'User', query: { id: props.detail.id_user } }"
              >
                <v-list-tile-action>
                  <v-icon color="secondary">person</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Diposting oleh</v-list-tile-title>
                  <v-list-tile-sub-title>{{
                    props.detail.username
                  }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-avatar class="viewer" v-viewer>
                  <img
                    v-lazy="c.PHOTO_PROFIL_URL + props.detail.photo_profil"
                    :alt="props.detail.username"
                  />
                </v-list-tile-avatar>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile
                v-ripple
                :to="{ name: 'Materi', query: { id: props.detail.id_materi } }"
              >
                <v-list-tile-action>
                  <v-icon color="secondary">chrome_reader_mode</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Materi</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.materi }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">local_offer</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Business Unit</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.laman }}
                    <small>{{ props.detail.laman_desc }}</small>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">style</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Tipe / Tempat</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.pel_tipe }} / {{ props.detail.pel_tempat }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
            </v-list>
            <v-list three-line subheader>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">timer</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Waktu</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.waktu_mulai | niceDate }}
                    <small>{{
                      props.detail.waktu_mulai | moment("from", "now")
                    }}</small>
                  </v-list-tile-sub-title>
                  <v-list-tile-sub-title
                    >Durasi {{ props.detail.durasi }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">note</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Keterangan </v-list-tile-title>
                  <v-list-tile-sub-title>{{
                    props.detail.keterangan | noEmpty
                  }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
            </v-list>
          </v-flex>
        </v-layout>
      </template>
    </pg-detail>
    <template v-if="!$route.query.id">
      <v-flex xs12>
        <v-card>
          <v-card-title class="py-2">
            <v-btn color="green" dark icon @click.stop="openInputDialog('ADD')">
              <v-icon>add</v-icon>
            </v-btn>
            <v-btn
              v-if="$route.name == 'TrainingSaya' || profil.role == 'ADMIN'"
              color="blue"
              :disabled="selected.length != 1"
              dark
              icon
              @click.stop="openInputDialog('UPDATE')"
            >
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn
              v-if="$route.name == 'TrainingSaya' || profil.role == 'ADMIN'"
              color="red"
              :disabled="selected.length == 0"
              dark
              icon
              @click.stop="deleteDialog = true"
            >
              <v-icon>delete</v-icon>
            </v-btn>
            <json-excel
              :data="selected"
              :export-fields="jsonFields"
              :name="`${$route.name}.xls`"
            >
              <v-btn color="indigo" :disabled="selected.length == 0" dark icon>
                <v-icon>file_download</v-icon>
              </v-btn>
            </json-excel>
            <v-btn
              :color="!filterOn ? 'grey' : 'orange'"
              :disabled="!sourceData.length && !filterOn"
              dark
              icon
              @click.stop="filterDialog = true"
            >
              <v-icon>filter_list</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Pencarian"
              clearable
              single-line
              hide-details
            >
            </v-text-field>
          </v-card-title>

          <v-data-table
            v-if="!$vuetify.breakpoint.xs"
            v-model="selected"
            :headers="headers"
            :items="sourceData"
            :search="search"
            :pagination.sync="pagination"
            :loading="!training_loaded"
            select-all
            item-key="id_training"
            :rows-per-page-items="pages"
            rows-per-page-text="Data/hlm"
            class="elevation-1"
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th>
                  <v-checkbox
                    :input-value="props.all"
                    :indeterminate="props.indeterminate"
                    primary
                    hide-details
                    @click.native="toggleAll"
                  >
                  </v-checkbox>
                </th>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable ',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                    header.align ? `text-xs-${header.align}` : 'text-xs-left'
                  ]"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <v-progress-linear
              slot="progress"
              color="primary"
              :height="3"
              indeterminate
            >
            </v-progress-linear>
            <template slot="items" slot-scope="props">
              <tr
                :active="props.selected"
                class="nowrap"
                @click="toggleExpand(props)"
              >
                <td style="width: 80px">
                  <v-checkbox
                    :input-value="props.selected"
                    @click.stop="props.selected = !props.selected"
                    primary
                    hide-details
                  >
                  </v-checkbox>
                </td>
                <td class="layout align-center">
                  <v-avatar
                    tile
                    :size="40"
                    class="viewer"
                    @click.stop=""
                    v-viewer
                  >
                    <img
                      v-lazy="
                        c.PHOTO_TRAINING_URL + defaultPhoto(props.item.photos)
                      "
                      style="width: 100%; margin: auto"
                      :alt="`Photo-${props.item.id_training}`"
                      :key="props.item.id_training"
                    />
                  </v-avatar>
                  <v-chip
                    small
                    label
                    @click.stop="
                      $router.push({
                        name: $route.name,
                        query: { id: props.item.id_training }
                      })
                    "
                  >
                    {{ props.item.materi }}
                  </v-chip>
                </td>
                <td>{{ props.item.waktu_mulai | moment("from", "now") }}</td>
                <td>{{ props.item.durasi }}</td>
                <td class="text-xs-center">{{ props.item.pel_tipe }}</td>
                <td class="text-xs-center">{{ props.item.pel_tempat }}</td>
                <td>{{ props.item.clients_grouped }}</td>
                <td class="text-xs-center">{{ props.item.total_client }}</td>
                <td class="text-xs-center">{{ props.item.total_peserta }}</td>
                <td>{{ props.item.trainers_grouped }}</td>
                <td class="text-xs-center">{{ props.item.total_trainer }}</td>
                <td>{{ props.item.keterangan | noEmpty }}</td>
                <td>{{ props.item.username }}</td>
              </tr>
            </template>
            <template
              slot="expand"
              slot-scope="props"
              v-if="$vuetify.breakpoint.xs"
            >
              <v-card
                flat
                :color="$vuetify.dark ? 'grey darken-1' : 'grey lighten-5'"
              >
                <table class="expanded">
                  <tr v-for="(header, i) in headers" :key="`rows-${i}`">
                    <td>{{ header.text }}</td>
                    <td v-if="header.value == 'waktu_mulai'">
                      {{ props.item.waktu_mulai | moment("from", "now") }}
                    </td>
                    <td v-else>{{ props.item[header.value] | noEmpty }}</td>
                  </tr>
                </table>
              </v-card>
            </template>
            <template slot="no-data">
              <v-alert
                :value="true"
                :color="training_loaded ? 'warning' : 'info'"
                :icon="training_loaded ? 'warning' : 'info'"
                class="pa-1"
              >
                <span v-if="!training_loaded">Mengambil data...</span>
                <span v-else>Tidak ada data.</span>
              </v-alert>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="warning"
              icon="warning"
              class="pa-1"
            >
              Kata kunci "{{ search }}" tidak ditemukan.
            </v-alert>
          </v-data-table>

          <v-data-iterator
            v-else
            v-model="selected"
            :items="sourceData"
            :pagination.sync="pagination"
            :loading="!training_loaded"
            :search="search"
            select-all
            item-key="id_training"
            :rows-per-page-items="pages"
            rows-per-page-text="Data/hlm"
            row
            wrap
          >
            <v-flex slot="item" slot-scope="props" xs12>
              <v-card>
                <v-card-media :height="200">
                  <img
                    :key="props.item.id_training"
                    style="width: 100%; margin: auto"
                    v-viewer
                    v-lazy="
                      c.PHOTO_TRAINING_URL + defaultPhoto(props.item.photos)
                    "
                    :alt="`Photo-${props.item.id_training}`"
                  />
                </v-card-media>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-checkbox
                      :input-value="props.selected"
                      @click.stop="props.selected = !props.selected"
                      class="ma-0 pa-0"
                      hide-details
                      primary
                    >
                    </v-checkbox>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      props.item.materi
                    }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{
                      props.item.waktu_mulai | moment("from", "now")
                    }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn
                      :to="{
                        name: $route.name,
                        query: { id: props.item.id_training }
                      }"
                      fab
                      flat
                      small
                      color="primary"
                    >
                      <v-icon>keyboard_arrow_right</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider></v-divider>
                <v-slide-y-transition>
                  <!-- <div v-show="props.selected"> -->
                  <v-list
                    dense
                    :class="props.selected ? 'secondary white--text' : ''"
                  >
                    <v-list-tile v-for="(header, i) in simpleHeaders" :key="i">
                      <v-list-tile-content>
                        <v-list-tile-title>{{ header.text }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{
                          props.item[header.value] | noEmpty
                        }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                  <!-- </div> -->
                </v-slide-y-transition>
              </v-card>
            </v-flex>
            <template slot="no-data">
              <v-alert
                :value="true"
                color="warning"
                icon="warning"
                class="pa-1"
              >
                <span v-if="status.loading">Loading...</span>
                <span v-else>Tidak ada data.</span>
              </v-alert>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="warning"
              icon="warning"
              class="pa-1"
            >
              Kata kunci "{{ search }}" tidak ditemukan.
            </v-alert>
          </v-data-iterator>
        </v-card>
      </v-flex>

      <pg-form-filter
        :dialog="filterDialog"
        :filterOn="filterOn"
        :filter="filter"
        :source="sourceData"
        :sourceOriginal="sourceOriginal"
        :title="title"
        @close="filterDialog = false"
        @toggle="
          filterOn = !filterOn;
          filterDialog = false;
        "
        @filtered="filterSource = $event"
      >
        <template slot="filter-content" slot-scope="props">
          <v-autocomplete
            append-icon="chrome_reader_mode"
            attach
            hide-details
            item-text="materi"
            item-value="id_materi"
            multiple
            :items="materiByLaman"
            v-model="props.filter.id_materi"
            label="Materi"
          >
          </v-autocomplete>
          <v-autocomplete
            append-icon="account_balance"
            attach
            hide-details
            item-text="client"
            item-value="id_client"
            multiple
            :items="clientByLaman"
            v-model="props.filter.id_client"
            label="Client"
          >
            <template slot="selection" slot-scope="data">
              {{ `${data.item.client} (${data.item.area})` }},
            </template>
            <template slot="item" slot-scope="data">
              <v-list-tile-content
                :class="{ 'red--text': !parseInt(data.item.active_client) }"
              >
                <v-list-tile-title>{{ data.item.client }}</v-list-tile-title>
                <v-list-tile-sub-title>{{
                  data.item.area
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
          <v-autocomplete
            append-icon="directions_run"
            attach
            hide-details
            item-text="trainer"
            item-value="id_trainer"
            multiple
            :items="trainer"
            v-model="props.filter.id_trainer"
            label="Trainer"
          >
            <template slot="selection" slot-scope="data">
              {{ `${data.item.trainer} (${data.item.trainer_divisi})` }},
            </template>
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <v-list-tile-title>{{ data.item.trainer }}</v-list-tile-title>
                <v-list-tile-sub-title>{{
                  data.item.trainer_divisi
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
          <v-autocomplete
            append-icon="style"
            attach
            hide-details
            item-text="pel_tipe"
            item-value="id_pel_tipe"
            multiple
            :items="pel_tipe"
            v-model="props.filter.id_pel_tipe"
            label="Tipe"
          >
          </v-autocomplete>
          <v-autocomplete
            append-icon="streetview"
            attach
            hide-details
            item-text="pel_tempat"
            item-value="id_pel_tempat"
            multiple
            :items="pel_tempat"
            v-model="props.filter.id_pel_tempat"
            label="Tempat"
          >
          </v-autocomplete>
          <v-autocomplete
            append-icon="person_outline"
            attach
            hide-details
            item-text="username"
            item-value="id_user"
            :items="user"
            multiple
            v-model="props.filter.id_user"
            label="User"
          >
            <template slot="item" slot-scope="data">
              <v-list-tile-avatar>
                <img
                  v-lazy="c.PHOTO_PROFIL_URL + data.item.photo_profil"
                  :alt="data.item.username"
                />
              </v-list-tile-avatar>
              <v-list-tile-content
                :class="{ 'red--text': !parseInt(data.item.active_user) }"
              >
                <v-list-tile-title>{{ data.item.username }}</v-list-tile-title>
                <v-list-tile-sub-title>{{
                  data.item.role
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
          <v-textarea
            auto-grow
            :rows="1"
            counter
            append-icon="note"
            hide-details
            type="text"
            v-model="props.filter.keterangan"
            label="Keterangan"
          >
          </v-textarea>
          <v-container grid-list-md class="pa-0">
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-datetime-picker
                  appendIcon="today"
                  hideDetails
                  locale="id-id"
                  label="Waktu Mulai"
                  :min="
                    $moment(props.filter.field.waktu_mulai[0]).format(
                      'YYYY-MM-DD'
                    )
                  "
                  :max="
                    $moment(props.filter.waktu_mulai[1]).format('YYYY-MM-DD')
                  "
                  v-model="props.filter.waktu_mulai[0]"
                >
                </v-datetime-picker>
              </v-flex>
              <v-flex xs12 sm6>
                <v-datetime-picker
                  appendIcon="today"
                  hideDetails
                  locale="id-id"
                  :min="
                    $moment(props.filter.waktu_mulai[0]).format('YYYY-MM-DD')
                  "
                  :max="
                    $moment(props.filter.field.waktu_mulai[1]).format(
                      'YYYY-MM-DD'
                    )
                  "
                  v-model="props.filter.waktu_mulai[1]"
                >
                </v-datetime-picker>
              </v-flex>
            </v-layout>
          </v-container>
          <v-range-slider
            v-model="props.filter.total_client"
            label="Total Client"
            append-icon="account_balance"
            hide-details
            style="margin-top: 40px"
            always-dirty
            :min="props.filter.field.total_client[0]"
            :max="props.filter.field.total_client[1]"
            thumb-label="always"
          >
          </v-range-slider>
          <v-range-slider
            v-model="props.filter.total_peserta"
            label="Total Peserta"
            append-icon="group"
            hide-details
            style="margin-top: 40px"
            always-dirty
            :min="props.filter.field.total_peserta[0]"
            :max="props.filter.field.total_peserta[1]"
            thumb-label="always"
          >
          </v-range-slider>
          <v-range-slider
            v-model="props.filter.total_trainer"
            label="Total Trainer"
            append-icon="directions_run"
            hide-details
            style="margin-top: 40px"
            always-dirty
            :min="props.filter.field.total_trainer[0]"
            :max="props.filter.field.total_trainer[1]"
            thumb-label="always"
          >
          </v-range-slider>
        </template>
      </pg-form-filter>
    </template>

    <pg-form-delete
      :dialog="deleteDialog"
      :selected="selected"
      :title="title"
      :primary_key="primary_key"
      @cancel="deleteDialog = false"
      @deleted="onDeleted"
      action="training/DELETE_TRAINING"
    >
      <template slot="item-detail" slot-scope="props">
        {{ props.item.materi }} ({{
          props.item.waktu_mulai | moment("from", "now")
        }})
      </template>
    </pg-form-delete>

    <training-input
      :dialog="inputDialog"
      :data="selected[0]"
      :title="title"
      :action="inputAction"
      :primary_key="primary_key"
      :primary_field="primary_field"
      :width="950"
      @cancel="inputDialog = false"
      @submitted="onSubmitted"
    >
    </training-input>
  </v-layout>
</template>

<script>
import _ from "lodash";
import c from "@/constants";
import JsonExcel from "vue-json-excel";
import VDatetimePicker from "@/components/widgets/input/DatetimePicker";
import PgFormDelete from "@/components/private/PgFormDelete";
import PgFormFilter from "@/components/private/PgFormFilter";
import PgDetail from "@/components/private/PgDetail";
import TrainingInput from "@/components/pages/input/TrainingInput";
import { mapState, mapGetters } from "vuex";

const defaultFilter = {
  id_materi: [],
  id_pel_tipe: [],
  id_pel_tempat: [],
  id_client: [],
  id_trainer: [],
  id_user: [],
  keterangan: "",
  total_client: [0, 100],
  total_peserta: [0, 100],
  total_trainer: [0, 100],
  waktu_mulai: ["", ""],
  field: {
    total_client: [0, 100],
    total_peserta: [0, 100],
    total_trainer: [0, 100],
    waktu_mulai: ["", ""]
  },
  format: {
    id_materi: c.FORMAT.options,
    id_pel_tipe: c.FORMAT.options,
    id_pel_tempat: c.FORMAT.options,
    id_client: c.FORMAT.options_group,
    id_trainer: c.FORMAT.options_group,
    id_user: c.FORMAT.options,
    keterangan: c.FORMAT.text,
    total_client: c.FORMAT.number,
    total_peserta: c.FORMAT.number,
    total_trainer: c.FORMAT.number,
    waktu_mulai: c.FORMAT.datetime
  },
  options_group: {
    id_client: "clients",
    id_trainer: "trainers"
  }
};

export default {
  name: "training",
  components: {
    JsonExcel,
    VDatetimePicker,
    PgDetail,
    PgFormDelete,
    PgFormFilter,
    TrainingInput
  },
  data() {
    return {
      // datatable
      headers: [
        { text: "MATERI", value: "materi" },
        { text: "WAKTU MULAI", value: "waktu_mulai" },
        { text: "DURASI", value: "durasi" },
        { text: "TIPE", value: "pel_tipe", align: "center" },
        { text: "TEMPAT", value: "pel_tempat", align: "center" },
        { text: "CLIENT", value: "clients_grouped" },
        { text: "TOTAL CLIENT", value: "total_client", align: "center" },
        { text: "TOTAL PESERTA", value: "total_peserta", align: "center" },
        { text: "TRAINER", value: "trainers_grouped" },
        { text: "TOTAL TRAINER", value: "total_trainer", align: "center" },
        { text: "KETERANGAN", value: "keterangan" },
        { text: "USER", value: "username" }
      ],
      pagination: {
        sortBy: "waktu_mulai",
        descending: true
      },
      pages: [7, 10, 25, { text: "Semua", value: -1 }],
      selected: [],
      search: "",
      // dialog
      title: "TRAINING",
      primary_field: "training",
      primary_key: "id_training",
      // delete
      deleteDialog: false,
      // filter
      filterDialog: false,
      filterSource: [],
      filterOn: false,
      filterHelperSourceUpdated: false,
      filter: _.cloneDeep(defaultFilter),
      // input
      inputDialog: false,
      inputAction: "ADD",
      // other
      c: c
    };
  },
  computed: {
    ...mapState(["status", "id_laman$"]),
    ...mapState("user", ["user"]),
    ...mapState("auth", ["profil"]),
    ...mapState("trainer", ["trainer"]),
    ...mapState("training", ["pel_tipe", "pel_tempat", "training_loaded"]),
    ...mapGetters("client", ["clientByLaman"]),
    ...mapGetters("materi", ["materiByLaman"]),
    simpleHeaders() {
      return this.headers.filter(
        h => !["materi", "waktu_mulai"].includes(h.value)
      );
    },
    jsonFields() {
      return this.headers.reduce(
        (obj, item) => ((obj[item.text] = item.value), obj),
        {}
      );
    },
    sourceOriginal() {
      /* eslint-disable */
      this.filterHelperSourceUpdated = true;
      let getter =
        this.$route.name == "TrainingSaya"
          ? "trainingSayaByLamanPeriode"
          : "trainingByLamanPeriode";
      return _.cloneDeep(this.$store.getters[`training/${getter}`]);
    },
    sourceData() {
      let source = _.cloneDeep(this.sourceOriginal);
      if (
        (this.filterOn && !_.isEqual(source, this.filterSource)) ||
        (this.filterHelperSourceUpdated && this.filterSource.length)
      ) {
        source = this.filterSource;
        /* eslint-disable */
        this.filterHelperSourceUpdated = false;
      }
      return source;
    }
  },
  methods: {
    toggleAll() {
      if (this.selected.length == this.sourceData.length) this.selected = [];
      else this.selected = _.cloneDeep(this.sourceData);
    },
    toggleExpand(props) {
      if (this.$vuetify.breakpoint.smAndDown) {
        if (!props.selected) props.expanded = !props.expanded;
        else props.expanded = false;
      } else props.expanded = false;
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    openInputDialog(action) {
      this.inputAction = action;
      this.inputDialog = true;
    },
    onSubmitted(new_id) {
      this.inputDialog = false;
      if (!this.$route.query.id) {
        if (this.inputAction == "UPDATE") {
          setTimeout(() => {
            this.selected = [];
          }, 1000);
        }
      } else {
        if (this.inputAction == "ADD") {
          this.$router.push({
            name: this.$route.name,
            query: { id: new_id }
          });
        }
      }
    },
    onDeleted(selected) {
      this.selected = selected;
      // if all success, then close dialog
      if (!this.selected.length) this.deleteDialog = false;
    },
    defaultPhoto(photos) {
      let photo_kegiatan = photos.filter(p => p.pel_photo_tipe == "KEGIATAN");
      return photo_kegiatan.length
        ? photo_kegiatan[0].pel_photo
        : "no-image.png";
    },
    showViewer() {
      let viewer = this.$el.querySelector(".images-viewer").$viewer;
      viewer.show();
    }
  },
  filters: {
    downloaderFiles: function(files, pel_file_tipe) {
      let file = files.filter(f => f.pel_file_tipe == pel_file_tipe)[0];
      if (file) {
        if (file.id_pel_file) return c.FILE_TES_URL + file.pel_file;
      }
      return "";
    }
  },
  watch: {
    id_laman$() {
      this.selected = [];
      this.pagination.page = 1;
    },
    $route(to, from) {
      if (to.name == "TrainingSaya") {
        this.selected = [];
        this.pagination.page = 1;
      }
    }
  },
  mounted() {}
};
</script>
